<template>
  <!-- Start Navbar -->
  <nav class="navbar-m" @click="hideForce($event)">
    <div class="container">
      <div class="nav-content">
        <router-link to="/" class="logo">
      <img v-if="logoSrc" :src="logoSrc" @error="onImgError" alt="brand-logo" />
        </router-link>

        <div class="links-container">
          <section v-if="showHeaderSearch" class="search nav-search" ref="navSearch">
            <input
              type="text"
              :placeholder="$t('nav.search')"
              class="search-input"
              ref="searchInput"
              v-model="searchBar"
              @input="onSearchInput"
              @focus="onSearchFocus"
              @blur="onSearchBlur"
              @keyup.enter.prevent="onSearchButtonClick"
              spellcheck="false"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              />
              <!-- @input="searchAds" -->
            <button type="button" class="search-btn" @click="onSearchButtonClick">
              <i class="fa-solid fa-magnifying-glass"></i>
            </button>
            <button
              v-if="showSearchClear"
              type="button"
              class="search-clear"
              aria-label="إغلاق البحث"
              @mousedown.prevent
              @click="clearSearch"
            >
              <i class="fa-solid fa-xmark"></i>
            </button>


            <div class="filteredSearch" v-if="showList">
              <ul v-if="searchItems.length">
                <li
                  v-for="ad in searchItems"
                  :key="ad.id"
                  class="adName"
                  @mousedown.prevent
                  @click="goToAd(ad.id, ad.name)"
                >
                  {{ ad.name }}
                </li>
              </ul>
              <ul v-else>
                <li>لا توجد إعلانات</li>
              </ul>
            </div>
          </section>

          <ul class="links" ref="ulBar">
            <router-link to="/" class="logo d-lg-none">
            <img v-if="logoSrc" :src="logoSrc" @error="onImgError" alt="" />
            </router-link>

            <li @click="toggleBar">
              <router-link
                to="/"
                class="links-a"
                :class="{ active: $route.path === '/' }"
              >
                {{ $t("nav.main") }}
              </router-link>
            </li>
            <li @click="toggleBar">
              <router-link
                to="/depatments"
                class="links-a"
                :class="{ active: $route.path === '/depatments' }"
              >
                {{ $t("nav.cats") }}
              </router-link>
            </li>
            <li @click="toggleBar">
              <router-link
                to="/favView"
                class="links-a"
                :class="{ active: $route.path === '/favView' }"
                @click="preventLogin"
              >
                {{ $t("nav.favs") }}
              </router-link>
            </li>
            <li @click="toggleBar" style="white-space: nowrap">
              <router-link
                to="/contactView"
                class="links-a"
                :class="{ active: $route.path === '/contactView' }"
              >
                {{ $t("nav.contact") }}
              </router-link>
            </li>

            <li @click="toggleBar" class="d-lg-none">
              <router-link
                :to="token ? '/uploadAds' : ''" 
                @click="preventLogin"
                class="links-a"
              >
                {{ $t('nav.upload') }}
              </router-link>
            </li>
          </ul>

          <div class="mobile">
            <div v-if="showHeaderSearch" class="search-mobile" ref="searchMobile">
              <div class="search-icons" @click="toggleSearch">
                <div class="search-i">
                  <i class="fa-solid fa-magnifying-glass"></i>
                </div>
                <div class="search-i search-close" @click="toggleSearch">
                  <i class="fa-solid fa-xmark"></i>
                </div>
              </div>
            </div>

            <span class="coll-icon" @click="toggleBar" ref="toggleIcon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </div>
        </div>

        <div class="navbar-icons">

          <div class="icons" v-if="token">
            <div class="dropdown-m-container" v-if="token">
              <img
                :src="userImg"
                class="nav-i show-drop"
                data-drop="user"
                @click="toggleDropdown($event)"
                ref="navProfile"
                @error="onProfileImgError"
                alt=""
              />
              <div
                class="user-drop dropdown-m"
                data-drop="user"
                :class="{ 'active-drop': showYes }"
              >
                <router-link
                  @click="preventLogin"
                  to="/editProfileView"
                  class="drop-link"
                >
                  {{ $t("nav.profile") }}
                </router-link>
                <router-link
                  @click="preventLogin"
                  to="/ratingView"
                  class="drop-link"
                >
                  {{ $t("nav.rates") }}
                </router-link>
                <router-link
                  @click="preventLogin"
                  to="/favView"
                  class="drop-link"
                >
                  {{ $t("nav.favs") }}
                </router-link>
                <router-link
                  @click="preventLogin"
                  to="/advertisementsView"
                  class="drop-link"
                >
                  {{ $t("nav.ads") }}
                </router-link>
                <router-link
                  @click="preventLogin"
                  to="/bannerView"
                  class="drop-link"
                >
                  بنراتي
                </router-link>
                <router-link to="/uploadAds" class="drop-link">
                  {{ ad_text }}
                </router-link>
                <router-link
                  to="/"
                  data-bs-toggle="modal"
                  data-bs-target="#imgModal"
                  class="drop-link"
                >
                  أضف بنر دعاية إعلانية
                </router-link>
                <router-link
                  to="/"
                  data-bs-toggle="modal"
                  data-bs-target="#alertModal"
                  class="drop-link"
                  v-if="hideLogOut"
                >
                  {{ $t("nav.logout") }}
                </router-link>
                <router-link
                  to="/"
                  data-bs-toggle="modal"
                  data-bs-target="#alert2Modal"
                  class="drop-link"
                  v-if="hideLogOut"
                >
                  {{ $t("nav.delete") }}
                </router-link>
              </div>
            </div>

            <div class="dropdown-m-container" v-if="token">
              <button
                type="button"
                class="noti-bell-btn"
                data-drop="not"
                @click="toggleDropdown2($event)"
                aria-label="الاشعارات"
              >
                <i class="fa-regular fa-bell nav-i"></i>
              </button>
              <span v-if="notyCount > 0" class="count_notification">{{ notyCount > 99 ? '99+' : notyCount }}</span>

              <div
                class="not-drop dropdown-m"
                data-drop="not"
                :class="{ 'active-drop': showYes2 }"
              >
                <div class="not-drop-header">
                  <span class="not-drop-title">{{ $t("nav.notifications") }} ({{ notyCount }})</span>
                  <button
                    v-if="slicedNotification.length && notyCount > 0"
                    type="button"
                    class="not-drop-markall"
                    @click="markAllRead"
                  >
                    <i class="fa-solid fa-check-double"></i> تحديد الكل كمقروء
                  </button>
                </div>

                <section v-if="slicedNotification.length" class="not-drop-body">
                  <div
                    class="drop-item"
                    v-for="noti in slicedNotification"
                    :key="noti.id"
                    :class="{ unread: !noti.is_read }"
                    @click="openNotification(noti)"
                  >
                    <span class="drop-text">
                      <span v-if="!noti.is_read" class="noti-dot"></span>
                      <span class="noti-title">{{ noti.title }}</span>
                      <span class="noti-body">{{ noti.body }}</span>
                    </span>
                    <button
                      class="drop-delete"
                      title="حذف"
                      @click.stop="removeNoti(noti.id)"
                    >
                      <i class="fa-solid fa-trash-can delete-icon"></i>
                    </button>
                  </div>
                </section>
                <section v-else class="d-flex justify-content-center py-3">
                  <span class="text-center noti-empty"> لا توجد اشعارات </span>
                </section>

                <router-link to="/notificationsView" class="more-anchor" @click="showYes2 = false">
                  <i class="fa-solid fa-list-ul"></i> {{ $t("common.more") }}
                </router-link>
              </div>
            </div>
          </div>

          <a
            href="#"
            class="main-btn sm"
            @click.prevent="openLoginModal"
            v-if="!token && !loginFrozen"
            style="margin-inline-end: 0px;"
          >
            {{ $t("nav.login") }}
          </a>

          <button
            v-if="!token && loginFrozen"
            type="button"
            class="main-btn sm is-disabled"
            disabled
            style="margin-inline-end: 0px;"
            title="تم إيقاف تسجيل الدخول مؤقتاً"
          >
            {{ $t("nav.login") }}
          </button>

          <router-link
            class="main-btn sm up"
            :to="token ? '/uploadAds' : ''"
            @click="preventLogin"
          >
            {{ ad_text || $t('nav.upload') }}
          </router-link>
        </div>
      </div>
    </div>
  </nav>
  <!-- End Navbar -->
  <!-- Logout modal -->
  <logOut />
  <removeAccount />
  <doneRemove />
  <regiesterComponent />
  <activationCode />
  <loginComponent :dialog="showLoginModal" @close="showLoginModal = false" />

  <!-- Notification full view modal -->
  <div v-if="showNotiModal" class="noti-modal-backdrop" @click.self="closeNotificationModal">
    <div class="noti-modal">
      <div class="noti-modal-header">
        <h5 class="noti-modal-title">{{ selectedNotification?.title }}</h5>
        <button class="noti-modal-close" @click="closeNotificationModal" aria-label="إغلاق">×</button>
      </div>
      <div class="noti-modal-body">
        <p class="noti-modal-text">{{ selectedNotification?.body }}</p>
        <small v-if="selectedNotification?.created_at" class="noti-modal-time">{{ selectedNotification.created_at }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import removeAccount from "../Shared/removeAccount.vue";
import doneRemove from "../Shared/doneRemove.vue";
import logOut from "../Shared/logOut.vue";
import regiesterComponent from "../auth/regiesterComponent.vue";
import activationCode from "../auth/activationCode.vue";
import loginComponent from "../auth/loginComponent.vue";
import axios from "axios";
import { Modal } from 'bootstrap';

export default {
  data() {
    return {
      searchBar: "",
      searchItems: [],
      showList: false,
      searchFocused: false,
      searchDebounceTimer: null,
      showYes: false,
      showYes2: false,
      logo: "",
      filterImg: require("../../assets/imgs/icons8-slider-60.png"),
      userImg: require("../../assets/imgs/user.png"),
      notiImg: require("../../assets/imgs/bell.png"),
      loggedIn: null,
      notifications: [],
      slicedNotification: [],
      nav_and_footer_data: {},
      notyCount: 0,
      hideLogOut: true,
      ad_text: "",
      token : "",
      assetBase: process.env.VUE_APP_ASSETS_BASE_URL || "",
      showLoginModal: false, // Added to control login modal visibility
      selectedNotification: null,
      loginFrozen: false,
    };
  },
  created() {
    this.syncLoginFrozen();
  },
  computed: {
    logoSrc(){
      const logo = this.nav_and_footer_data?.logo;
      if (logo) return this.$resolveAsset(logo);
      return this.logo;
    },
    faviconSrc(){
      const raw = String(this.nav_and_footer_data?.fav_icon || "").trim();
      if (!raw) return "data:,";
      return `/dashboard/site-favicon.ico?v=${encodeURIComponent(raw)}`;
    },
    showSearchClear() {
      return this.searchFocused || this.showList || ((this.searchBar || "").trim().length > 0);
    },
    showHeaderSearch() {
      return this.$route?.name !== "catogryView";
    }
  },
  methods: {
    syncAuthState() {
      const nextToken = sessionStorage.getItem("token") || "";
      const changed = this.token !== nextToken;
      this.token = nextToken;
      this.loggedIn = !!nextToken;

      if (!nextToken) {
        this.notifications = [];
        this.slicedNotification = [];
        this.notyCount = 0;
        this.showYes = false;
        this.showYes2 = false;
        return;
      }

      if (changed) {
        this.getNotficationCount();
        this.getNotification();
      }
    },
    syncLoginFrozen() {
      const loginDisabled = localStorage.getItem('login_disabled') === 'true';
      const maintenanceEnabled = localStorage.getItem('maintenance_enabled') === 'true';
      this.loginFrozen = loginDisabled || maintenanceEnabled;
    },
    openNotification(noti) {
      this.selectedNotification = noti || null;
      this.showNotiModal = true;
      // Mark this notification as read when viewed so it moves to the "more" list.
      if (noti && !noti.is_read) {
        noti.is_read = true;
        this.markAsRead(noti.id);
      }
    },
    async markAsRead(notificationId) {
      try {
        await axios.post(`notifications/${notificationId}/read`);
        this.notyCount = Math.max(0, this.notyCount - 1);
        this.refreshSliced();
      } catch (err) {
        // ignore; counter will self-correct on next fetch
      }
    },
    async markAllRead() {
      const unread = this.notifications.filter((n) => !n.is_read);
      if (!unread.length) return;
      try {
        await Promise.all(unread.map((n) => axios.post(`notifications/${n.id}/read`)));
        this.notifications.forEach((n) => (n.is_read = true));
        this.notyCount = 0;
        this.refreshSliced();
      } catch (err) {
        this.getNotficationCount();
      }
    },
    refreshSliced() {
      const unread = this.notifications.filter((n) => !n.is_read);
      const latest = [...this.notifications].sort((a, b) => String(b.created_at).localeCompare(String(a.created_at)));
      this.slicedNotification = (unread.length ? unread : latest).slice(0, 5);
    },
    closeNotificationModal() {
      this.showNotiModal = false;
      this.selectedNotification = null;
    },
    async removeNoti(notificationId) {
      // تأكيد قبل الحذف
      try {
        let proceed = true;
        if (this.$swal) {
          const result = await this.$swal({
            icon: "warning",
            title: "هل تريد حذف الإشعار؟",
            showCancelButton: true,
            confirmButtonText: "نعم، حذف",
            cancelButtonText: "إلغاء",
            reverseButtons: true,
          });
          proceed = !!result?.isConfirmed;
        } else {
          proceed = window.confirm("هل تريد حذف هذا الإشعار؟");
        }
        if (!proceed) return;

        const wasUnread = this.notifications.some((n) => n.id === notificationId && !n.is_read);
        const res = await axios.delete(`delete-notification/${notificationId}`);
        if (res?.data?.key === "success") {
          // أزل الإشعار من القائمة وحدّث العداد
          this.notifications = this.notifications.filter((n) => n.id !== notificationId);
          if (wasUnread) {
            this.notyCount = Math.max(0, this.notyCount - 1);
          }
          this.refreshSliced();
          if (this.$swal) {
            this.$swal({
              icon: "success",
              title: res.data.msg,
              timer: 1600,
              showConfirmButton: false,
            });
          }
        } else {
          if (this.$swal) {
            this.$swal({
              icon: "error",
              title: res?.data?.msg || "فشل حذف الإشعار",
              timer: 1600,
              showConfirmButton: false,
            });
          }
        }
      } catch (err) {
        console.error(err);
        if (this.$swal) {
          this.$swal({
            icon: "error",
            title: "حدث خطأ أثناء الحذف",
            timer: 1600,
            showConfirmButton: false,
          });
        }
      }
    },
    onImgError(e) {
      e.target.src = this.logo;
    },
    onProfileImgError(e) {
      e.target.src = this.userImg;
    },
    preventLogin() {
      if (!this.token) {
        this.$swal({
          icon: "error",
          title: "قم بتسجيل الدخول بحسابك أولاً",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    updateFavicon(){
      try{
        const href = this.faviconSrc;
        document
          .querySelectorAll("link[rel='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']")
          .forEach((node) => node.remove());

        const createIcon = (rel) => {
          const link = document.createElement('link');
          link.setAttribute('rel', rel);
          link.setAttribute('href', href);
          if (rel !== 'apple-touch-icon') {
            link.setAttribute('type', 'image/x-icon');
          }
          document.head.appendChild(link);
        };

        createIcon('apple-touch-icon');
        createIcon('icon');
        createIcon('shortcut icon');
      }catch(_){
        void 0;
      }
    },
    openBannerCheck() {
      if (!this.token) {
        this.preventLogin();
      } else {
        const modalEl = document.getElementById('imgModal');
        if (modalEl) {
          const modal = Modal.getOrCreateInstance(modalEl);
          modal.show();
        } else {
          console.error('Modal #imgModal not found');
        }
      }
    },
    openLoginModal() {
      if (this.loginFrozen) return;
      this.showLoginModal = true;
      const modalEl = document.getElementById('loginModal');
      if (modalEl) {
        const modal = Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    },
    goToAd(id, name) {
      this.searchBar = name;
      this.showList = false;
      this.searchFocused = false;
      const searchSection = this.$refs.navSearch;
      if (searchSection) searchSection.classList.remove("active");
      localStorage.setItem("currentAd", "true");
      if (this.$route.name === 'searchResults') {
        if (this.$route.query.q === name) {
          window.dispatchEvent(new CustomEvent('refetch-search', { detail: name }));
        } else {
          this.$router.replace({ query: { q: name } }).catch(() => {});
        }
      } else {
        this.$router.push({ name: 'searchResults', query: { q: name } }).catch(() => {});
      }
    },
    toggleBar() {
      const showSideBar = this.$refs.toggleIcon;
      const sideBar = this.$refs.ulBar;

      sideBar.classList.toggle("active");
      showSideBar.classList.toggle("active");
    },
    onSearchFocus() {
      this.searchFocused = true;
      const q = (this.searchBar || "").trim();
      if (q.length > 0) {
        this.showList = true;
        this.scheduleSearch();
      }
    },
    onSearchBlur() {
      this.searchFocused = false;
    },
    onSearchInput() {
      const q = (this.searchBar || "").trim();
      if (q.length === 0) {
        this.searchItems = [];
        this.showList = false;
        return;
      }
      this.showList = true;
      this.searchAds(); // Call search immediately for instant results
    },
    async searchAds() {
      try {
        const q = (this.searchBar || "").trim();
        if (q.length === 0) {
          this.searchItems = [];
          this.showList = false;
          return;
        }
        const res = await axios.get("search-advertisements", { params: { name: q } });
        if (res?.data?.key === "success") {
          this.searchItems = res?.data?.data?.advertisements || [];
        } else {
          this.searchItems = [];
        }
      } catch (err) {
        this.searchItems = [];
      }
    },
    async onSearchButtonClick() {
      const q = (this.searchBar || '').trim();
      if (q.length === 0) {
        // If empty, just toggle suggestions box to hint typing
        this.showList = true;
        return;
      }
      // Navigate to search results page with query param
      if (this.$route.name === 'searchResults') {
        if (this.$route.query.q === q) {
          window.dispatchEvent(new CustomEvent('refetch-search', { detail: q }));
        } else {
          this.$router.replace({ query: { q } }).catch(() => {});
        }
      } else {
        this.$router.push({ name: 'searchResults', query: { q } }).catch(() => {});
      }
      this.searchItems = [];
      this.showList = false;
      this.searchFocused = false;
      this.searchBar = "";
      const searchSection = this.$refs.navSearch;
      if (searchSection) searchSection.classList.remove("active");
      const input = this.$refs.searchInput;
      if (input && typeof input.blur === "function") input.blur();
    },
    clearSearch() {
      this.searchBar = "";
      this.searchItems = [];
      this.showList = false;
      this.searchFocused = false;
      const searchSection = this.$refs.navSearch;
      if (searchSection) searchSection.classList.remove("active");
      const input = this.$refs.searchInput;
      if (input && typeof input.blur === "function") input.blur();
    },
    toggleSearch() {
      const searchBox = this.$refs.navSearch;
      const willOpen = !searchBox.classList.contains("active");
      searchBox.classList.toggle("active");
      const q = (this.searchBar || "").trim();
      this.showList = willOpen && q.length > 0;
      if (willOpen) {
        const input = this.$refs.searchInput;
        if (input && typeof input.focus === "function") input.focus();
      }
    },
    handleClickOutside(event) {
      const searchSection = this.$refs.navSearch;
      const profileMenu = this.$refs.navProfile;

      // Check if the click was outside the search section and the profile menu
      const clickedOutsideSearch = searchSection && !searchSection.contains(event.target);
      const clickedOutsideProfile = profileMenu && !profileMenu.contains(event.target);

      // Close the search bar if it's open and clicked outside
      if (this.showList && clickedOutsideSearch) {
        searchSection.classList.remove("active");
        this.showList = false;
        this.showYes = false;
        this.showYes2 = false;
      }

      // Close the profile dropdown if it's open and clicked outside
      if (this.showYes && clickedOutsideProfile) {
        this.showYes = false;
        this.showList = false;
        searchSection.classList.remove("active");
      }
      
      // Close the notifications dropdown if it's open and clicked outside
      if (this.showYes2 && clickedOutsideProfile) {
        this.showYes2 = false;
        searchSection.classList.remove("active");
        this.showList = false;
      }
      
      // Close both dropdowns if clicked outside of both
      if (clickedOutsideSearch && clickedOutsideProfile) {
        searchSection.classList.remove("active");
        this.showList = false;
        this.showYes = false;
        this.showYes2 = false;
      }
    },
    toggleDropdown(event) {
      this.showYes = !this.showYes;
      this.showYes2 = false; // Close the notifications dropdown if open
      event.stopPropagation();
    },
    toggleDropdown2(event) {
      this.showYes2 = !this.showYes2;
      this.showYes = false; // Close the profile dropdown if open
      event.stopPropagation();
    },
    hideForce(event) {
      this.showYes = false;
      this.showYes2 = false; // Hide both dropdowns on navbar click
      event.stopPropagation();
    },
    changeLocale() {
      let lang = this.$i18n.locale === "ar" ? "en" : "ar";
      sessionStorage.setItem("lang", lang);
      location.reload();
    },
    async getHomeLogo() {
      try {
        const res = await axios.get("home", { headers: { 'X-No-Auth-Redirect': true } });
        this.nav_and_footer_data = res?.data?.data?.nav_and_footer_data || {};
        this.ad_text = res?.data?.data?.ad_text || "";
        this.updateFavicon();
      } catch (err) {
        this.updateFavicon();
        }
    },
    async getNotficationCount() {
      // استدعِ العداد فقط عند توفر التوكن
      if (!this.token) {
        this.notyCount = 0;
        return;
      }
      try {
        const res = await axios.get("count-notifications");
        this.notyCount = res?.data?.data?.count || 0;
      } catch (err) {
        this.notyCount = 0;
      }
    },
    async getNotification() {
      // اجلب الإشعارات فقط عند توفر التوكن
      if (!this.token) {
        this.notifications = [];
        this.slicedNotification = [];
        return;
      }
      try {
        const res = await axios.get("notifications");
        this.notifications = res?.data?.data?.notifications || [];
        this.refreshSliced();
      } catch (err) {
        this.notifications = [];
        this.slicedNotification = [];
      }
    },
    async pollNotifications() {
      if (!this.token) {
        this._pollLastCount = null;
        return;
      }
      const prev = this._pollLastCount;
      await this.getNotficationCount();
      if (prev !== null && this.notyCount !== prev) {
        this.getNotification();
      }
      this._pollLastCount = this.notyCount;
    },
  },
  watch: {
    searchBar() {
      if ((this.searchBar || "").trim().length === 0) this.showList = false;
    },
  },
  mounted() {
    this.getHomeLogo();
    this.syncAuthState();
    this.syncLoginFrozen();
    this._syncLoginFrozen = () => this.syncLoginFrozen();
    this._syncAuthState = () => this.syncAuthState();
    this._storageBridge = (event) => {
      if (event && event.key && event.key !== 'auth_session_event') return;
      this.syncAuthState();
      this.syncLoginFrozen();
    };
    this._loginFrozenInterval = setInterval(this._syncLoginFrozen, 2000);
    window.addEventListener('storage', this._syncLoginFrozen);
    window.addEventListener('storage', this._storageBridge);
    window.addEventListener('auth:changed', this._syncAuthState);
    this._onNotificationsChanged = () => {
      this.getNotficationCount();
      this.getNotification();
    };
    window.addEventListener('notifications:changed', this._onNotificationsChanged);
    // نفّذ طلبات تتطلب توكن فقط إن وجد
    this.getNotficationCount();
    this.getNotification();

    if (localStorage.getItem("notApproved") === "true") {
      this.hideLogOut = false;
    }

    document.addEventListener("click", this.handleClickOutside);
    this._notificationPoll = setInterval(() => this.pollNotifications(), 20000);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    if (this._notificationPoll) clearInterval(this._notificationPoll);
    if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
    if (this._loginFrozenInterval) clearInterval(this._loginFrozenInterval);
    if (this._syncLoginFrozen) window.removeEventListener('storage', this._syncLoginFrozen);
    if (this._storageBridge) window.removeEventListener('storage', this._storageBridge);
    if (this._syncAuthState) window.removeEventListener('auth:changed', this._syncAuthState);
    if (this._onNotificationsChanged) window.removeEventListener('notifications:changed', this._onNotificationsChanged);
  },
  components: {
    removeAccount,
    doneRemove,
    logOut,
    regiesterComponent,
    activationCode,
    loginComponent,
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
  color: #262626;
}
.lang-m-spe {
  background-color: #2abdc7;
  color: #fff;
  padding: 10px 12px;
  border-radius: 5px 12px;
}
.nav-search {
  max-width: 500px;
  width: 100%;
  position: relative;
  margin-right: auto;
  margin-left: auto;
}
.nav-search .search-input {
  padding-inline-end: 44px;
  padding-inline-start: 55px; /* Add padding for start side (Right in RTL, Left in LTR) */
}
.nav-search .search-input:-webkit-autofill,
.nav-search .search-input:-webkit-autofill:hover,
.nav-search .search-input:-webkit-autofill:focus {
  -webkit-text-fill-color: inherit;
  -webkit-background-clip: text;
  transition: background-color 50000s ease-in-out 0s;
  text-decoration: none !important;
  box-shadow: none !important;
}
.nav-search .search-clear {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 12px;
  width: 32px;
  height: 32px;
  border: 1px solid #e0e0e0;
  background: #f8f9fa; /* Light box background */
  border-radius: 6px; /* Rounded box */
  color: #010135;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
  z-index: 2;
  transition: all 0.2s ease;
}
.nav-search .search-clear:hover {
  background-color: #e9ecef;
  color: #d62d20; /* Red on hover for clear action */
}
.filteredSearch {
  position: absolute;
  width: 100%;
  max-height: 200px;
  border-radius: 0 0 5px 5px;
  border: 1px solid #2abdc7;
  padding: 10px 5px;
  background-color: #fff;
  top: 45px;
  right: 0;
  overflow-y: auto;
  z-index: 99;
  li.adName {
    cursor: pointer;
    padding-bottom: 8px;
    &:not(:last-of-type) {
      border-bottom: 1px solid #dfdddd;
    }
  }
  @media (max-width : 991px){
    top:68px;
  }
}
.drop-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 8px;
  cursor: pointer;
}
.drop-text {
  display: inline-block;
  color: #262626;
}
.noti-title {
  font-weight: 700;
  display: block;
  margin-bottom: 2px;
}
.noti-body {
  display: block;
}
.drop-delete {
  background: transparent;
  border: none;
  color: #e23d3d;
  cursor: pointer;
}
.drop-delete .delete-icon {
  font-size: 14px;
}
.count_notification {
  position: absolute;
  background: #e23d3d;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  color: #fff;
  right: -4px;
  top: -4px;
  padding: 0 4px;
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,.25);
}

.noti-bell-btn {
  position: relative;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px;
  color: #010135;
  display: flex;
  align-items: center;
  justify-content: center;
}
.noti-bell-btn .nav-i {
  font-size: 24px;
  color: inherit;
}

.not-drop-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 14px;
  border-bottom: 1px solid #eee;
  background: #f8fafc;
  border-radius: 8px 8px 0 0;
}
.not-drop-title {
  font-weight: 700;
  font-size: 14px;
  color: #262626;
}
.not-drop-markall {
  background: transparent;
  border: 1px solid #2abdc7;
  color: #2abdc7;
  font-size: 12px;
  border-radius: 6px;
  padding: 4px 10px;
  cursor: pointer;
  transition: all .2s;
}
.not-drop-markall:hover {
  background: #2abdc7;
  color: #fff;
}

.not-drop-body {
  max-height: 300px;
  overflow-y: auto;
}
.not-drop-body .drop-item {
  position: relative;
  padding: 10px 14px;
  transition: background .2s;
}
.not-drop-body .drop-item:hover {
  background: #f2fbff;
}
.drop-item.unread {
  background: #eefcff;
}
.drop-item.unread:hover {
  background: #e2f8fd;
}
.noti-dot {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  inset-inline-start: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2abdc7;
}
.drop-item .drop-text {
  padding-inline-start: 10px;
}
.drop-item.unread .drop-text {
  padding-inline-start: 14px;
}
.noti-empty {
  color: #999;
  font-size: 13px;
}
.more-anchor {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px;
  border-top: 1px solid #eee;
  color: #2abdc7;
  font-weight: 700;
  font-size: 13px;
  text-align: center;
}
.more-anchor:hover {
  background: #f8fafc;
  color: #1799a3;
}
.not-drop {
  width: 360px;
  max-width: 92vw;
}
.links {
  gap: 35px !important;
}
.user-drop {
  max-height: unset !important;
  height: fit-content;
}

/* Simple notification modal */
.noti-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.35);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.noti-modal {
  background: #fff;
  width: min(520px, 92vw);
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
}
.noti-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-bottom: 1px solid #eee;
}
.noti-modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}
.noti-modal-close {
  background: transparent;
  border: none;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}
.noti-modal-body {
  padding: 14px;
}
.noti-modal-text {
  margin: 0 0 8px;
}
.noti-modal-time {
  color: #777;
}

  /* Mobile Icons (Stacked) */
  .mobile-controls {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-inline-end: 15px; 
    align-items: center;
  }
  .control-box {
    width: 35px;
    height: 35px;
    background: #2ABDC7; /* Teal */
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  }
  .control-box i {
    font-size: 16px;
  }
  .coll-icon span {
    display: block;
    width: 18px;
    height: 2px;
    background: #fff;
    margin-bottom: 3px;
  }
  .coll-icon span:last-child {
    margin-bottom: 0;
  }

  /* Auth Buttons (Stacked) */
  .auth-buttons-container {
    flex-direction: column;
    align-items: center; 
    gap: 8px;
    margin-inline-start: 15px; 
  }
  .login-link {
    font-size: 13px;
    margin-bottom: 0;
    order: 2; /* Login text BELOW button */
    white-space: nowrap;
  }
  .add-ad-btn {
    padding: 6px 12px;
    font-size: 12px;
    border-radius: 6px;
    min-width: auto;
    text-align: center;
    order: 1; /* Button ON TOP */
  }

  /* Small button style */
  .main-btn.sm {
    padding: 8px 15px; /* Smaller padding */
    font-size: 14px; /* Smaller font size */
    height: auto; /* Allow height to adjust based on content */
  }

  .main-btn.sm.is-disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }

  
</style>
